import { useEffect, useState } from "react";
// REDUX
import { useGetOrganizationsLightQuery } from "../../redux/organizations/organizationAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { OganizationLightInterface } from "../../interfaces/Organizations.interface";

export default function useGetAllOrganizationsLight() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [organizations, setOrganizations] = useState<OganizationLightInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetOrganizationsLightQuery(
		{ token },
		{ skip: !token, refetchOnMountOrArgChange: false }
	);

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setOrganizations(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		organizationsLight: organizations,
		isLoadingGetAllOrganizationsLight: isLoading || isFetching,
		errorMessageGetAllOrganizationsLight: errorMessage,
		isErrorGetAllOrganizationsLight: isError,
		totalRowsGetAllOrganizationsLight: data?.total ?? 0,
	};
}
